import { useEffect, useState } from 'react';
import { SnackbarProvider as LibSnackbarProvider } from 'notistack';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    pointerEvents: 'auto',
  },
  '@global': {
    '.SnackbarContainer-root': {
      gap: theme.spacing(),
    },
  },
}));

export default function SnackbarProvider({ children }) {
  const classes = useStyles();
  const [domRoot, setDomRoot] = useState(null);

  useEffect(() => {
    const el = document.createElement('div');
    el.id = 'snackbar-root';
    document.body.appendChild(el);
    setDomRoot(el);
    return () => el.remove();
  }, []);

  return (
    <LibSnackbarProvider
      maxSnack={3}
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      classes={{ root: classes.root }}
      domRoot={domRoot || undefined}
    >
      {children}
    </LibSnackbarProvider>
  );
}
